<div class="sidebar">
    <ng-content></ng-content>
</div>
